export function getCycleId({
  cycleYear = 0,
  cycleNumber = 0,
}: {
  cycleYear?: number | null;
  cycleNumber?: number | null;
}): number {
  if (!cycleYear || !cycleNumber) {
    return 0;
  }

  if (cycleNumber < 10) {
    return Number(`${cycleYear}0${cycleNumber}`);
  }

  return Number(`${cycleYear}${cycleNumber}`);
}
